import { UserRole } from '@hms/shared';

export const OR_SCHEDULE_ROUTE = 'ORSchedule';
export const OR_SCHEDULE_PATH = '/surgery/schedule';

export const SURGERY_DETAIL_ROUTE = 'SurgeryDetail';
export const SURGERY_DETAIL_PATH = '/surgery/surgeries/:id';

export const RECOVERY_BOARD_ROUTE = 'RecoveryBoard';
export const RECOVERY_BOARD_PATH = '/surgery/recovery';

/** Decision Q8: the roles that book, reschedule and cancel surgeries. */
export const SURGERY_BOOKING_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.DOCTOR, UserRole.RECEPTIONIST];

/** The OR schedule's roles: nurses read it, with no action. */
export const OR_SCHEDULE_ROLES: string[] = [...SURGERY_BOOKING_ROLES, UserRole.NURSE];

/** Decision Q8's read roles open a surgery; what each may change on it follows the roles below. */
export const SURGERY_DETAIL_ROLES: string[] = OR_SCHEDULE_ROLES;

/** The read roles to whom the API answers a surgery's intra-op and post-op notes and its anesthesia plan as null. */
export const SURGERY_CLINICAL_DATA_HIDDEN_ROLES: readonly string[] = [UserRole.RECEPTIONIST];

/** The clinical staff and the administrators tick the pre-op checklist; receptionists read it. */
export const SURGERY_PRE_OP_CHECKLIST_TICK_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.DOCTOR, UserRole.NURSE];

/** The roles the consent-form API lets sign a consent. */
export const SURGERY_CONSENT_SIGN_ROLES: string[] = [UserRole.DOCTOR, UserRole.NURSE, UserRole.RECEPTIONIST, UserRole.ADMIN, UserRole.HOSPITAL_ADMIN];

/** The roles the exam-order and prescription APIs let list an encounter's orders. */
export const SURGERY_ORDER_READ_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.DOCTOR, UserRole.NURSE];

/** Only doctors place exam orders and prescriptions. */
export const SURGERY_ORDER_ROLES: string[] = [UserRole.DOCTOR];

/**
 * The roles that start, stop and document any surgery of their scope (its notes and materials); the team's own doctors
 * and nurses do too (`mayActOnSurgery`). The organization admin does not: the API refuses it with a 403.
 */
export const SURGERY_INTRA_OP_ADMIN_ROLES: readonly string[] = [UserRole.HOSPITAL_ADMIN];

/** The roles that edit the team of any surgery of their scope, besides its own doctors and nurses. */
export const SURGERY_TEAM_EDIT_ADMIN_ROLES: readonly string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN];

/** The administrator roles of `mayWritePostOp`. */
export const SURGERY_POST_OP_ADMIN_ROLES: readonly string[] = [UserRole.HOSPITAL_ADMIN];

/**
 * The roles that record recovery vitals, write the recovery notes, tick the discharge criteria and discharge: any nurse or
 * doctor of the hospital, and its hospital admin.
 */
export const SURGERY_RECOVERY_ACTOR_ROLES: readonly string[] = [UserRole.NURSE, UserRole.DOCTOR, UserRole.HOSPITAL_ADMIN];

/** The recovery actors whom the appointments API lets book, so the manual-booking notice offers them the booking (CORA-394). */
export const SURGERY_FOLLOW_UP_MANUAL_BOOKING_ROLES: readonly string[] = [UserRole.NURSE, UserRole.DOCTOR];

/**
 * The recovery board's roles: the clinical roles that act on it, and the organization admin, whom the board API lets
 * read every hospital's recovery but not act on it.
 */
export const RECOVERY_BOARD_ROLES: string[] = [...SURGERY_RECOVERY_ACTOR_ROLES, UserRole.ADMIN];

export const SURGERY_MATERIALS_ROUTE = 'SurgeryMaterialsManagement';
export const SURGERY_MATERIALS_PATH = '/admin/surgery-materials';

/** The roles that keep each surgery type's default materials and kits (CORA-386, CORA-393). */
export const SURGERY_MATERIALS_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN, UserRole.STOCK_MANAGER];

export const SURGEON_PERFORMANCE_REPORT_ROUTE = 'SurgeonPerformanceReports';
export const SURGEON_PERFORMANCE_REPORT_PATH = '/reports/surgeon-performance';

export const OR_EFFICIENCY_REPORT_ROUTE = 'OrEfficiencyReports';
export const OR_EFFICIENCY_REPORT_PATH = '/reports/or-efficiency';

/** The roles the surgery metrics APIs answer: the surgeon performance (CORA-395) and OR efficiency (CORA-396) reports. */
export const SURGERY_REPORT_ROLES: string[] = [UserRole.ADMIN, UserRole.HOSPITAL_ADMIN];
